import { Header, Paragraph } from '@/components/common/Typography';
import { useUserData } from '@/services/user';
import FinancialEntitiesPermissionsSection from './FinancialEntitiesPermissionsSection';

export default function SharingAccountsSection() {
    const { activePartnershipId } = useUserData();
    if (!activePartnershipId) {
        return <></>;
    }

    return (
        <>
            <Header mb={3}>Your accounts</Header>
            <Paragraph color="textMuted" mb={5}>
                Sharing enables your partner to see the account balance, but
                they cannot move money with or make changes to the account
                unless you explicitly consent that the account is jointly owned
                by both of you.
            </Paragraph>
            <FinancialEntitiesPermissionsSection
                activePartnershipId={activePartnershipId}
                showBalance
                mb={12}
            />
        </>
    );
}
